import React, { useEffect, useState } from 'react';
import {
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
} from '@mui/material';
import ChipInput from '../../commun/ChipInput';
import './Addmission.css';
import DisponibilitePicker from '../../commun/DisponibilitePicker';
import { fetchSkillsFromLightcast } from '../../../services/lightcastApi';
import { parseSecteursExcel } from '../../commun/autofillExcel';
import {
  contractTypeOptions,
  languageOptions,
  languageLevelOptions,
} from '../../commun/constants/options';
import { IconButton, Tooltip } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

const StepTwo = ({ data, errors, onChange }) => {
  const [skillSuggestions, setSkillSuggestions] = useState([]);
  const [secteurOptions, setSecteurOptions] = useState([]);
  const [query, setQuery] = useState('');

  // Chargement dynamique des compétences via API Lightcast
  useEffect(() => {
    if (query.trim().length > 2) {
      const delayDebounce = setTimeout(() => {
        fetchSkillsFromLightcast(query.trim())
          .then((skills) => {
            setSkillSuggestions(skills || []);
          })
          .catch(console.error);
      }, 500);
      return () => clearTimeout(delayDebounce);
    } else {
      setSkillSuggestions([]);
    }
  }, [query]);

  // Chargement des secteurs depuis Excel (temporaire)
  useEffect(() => {
    parseSecteursExcel().then(setSecteurOptions).catch(console.error);
  }, []);

  const handleLangueChange = (index, field, value) => {
    const updated = [...data.langues];
    updated[index] = {
      ...updated[index],
      [field]: value,
    };
    onChange('langues', updated);
  };

  const addLangue = () => {
    const updated = [...data.langues, { langue: '', niveau: '' }];
    onChange('langues', updated);
  };

  useEffect(() => {
    if (!data.langues || data.langues.length === 0) {
      onChange('langues', [{ langue: '', niveau: '' }]);
    }
  }, [data.langues, onChange]);

  const removeLangue = (index) => {
  const updated = data.langues.filter((_, i) => i !== index);
  onChange('langues', updated.length ? updated : [{ langue: '', niveau: '' }]);
};

  return (
    <form className="step-two-container">
<ChipInput
  label="Compétences clés"
  required
  values={data.competences}
  onChange={(newValues) => onChange('competences', newValues)}
  onInputChange={(input) => setQuery(input)}
  suggestions={skillSuggestions}
  error={!!errors.competences}
  helperText={errors.competences}
/>


      <DisponibilitePicker
        label="Disponibilité"
        value={data.disponibilite}
        onChange={(d) => onChange('disponibilite', d)}
        error={!!errors.disponibilite}
        helperText={errors.disponibilite}
        required
      />

      <ChipInput
        label="Types de contrat "
        required
        values={data.typeContrat || []}
        onChange={(newValues) => onChange('typeContrat', newValues)}
        suggestions={contractTypeOptions.map((option) => option.label)}
        error={!!errors.typeContrat}
        helperText={errors.typeContrat}
      />

      <TextField
        label="Années d'expérience"
        value={data.experience}
        error={!!errors.experience}
        helperText={errors.experience}
        onChange={(e) => onChange('experience', e.target.value)}
        className="step-two-half"
      />

      <TextField
        label="Formation"
        value={data.formation}
        error={!!errors.formation}
        helperText={errors.formation}
        onChange={(e) => onChange('formation', e.target.value)}
        className="step-two-half"
      />

      <FormControl error={!!errors.secteur}>
        <InputLabel>Secteur d'activité</InputLabel>
        <Select
          value={data.secteur || ''}
          onChange={(e) => onChange('secteur', e.target.value)}
          label="Secteur d'activité"
        >
          {secteurOptions.map((option) => (
            <MenuItem key={option} value={option}>
              {option}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <div className="langues-section">
      {data.langues.map((entry, index) => (
      <div className="langue-row" key={index}>
      <FormControl className="step-two-half">
      <InputLabel>Langue</InputLabel>
      <Select
      value={entry.langue || ''}
      onChange={(e) =>
      handleLangueChange(index, 'langue', e.target.value)
      }
      label="Langue"
      >
      {languageOptions.map((option) => (
      <MenuItem key={option.value} value={option.value}>
      {option.label}
      </MenuItem>
      ))}
      </Select>
      </FormControl>

      <FormControl className="step-two-half">
      <InputLabel>Niveau</InputLabel>
      <Select
      value={entry.niveau || ''}
      onChange={(e) =>
      handleLangueChange(index, 'niveau', e.target.value)
      }
      label="Niveau"
      >
      {languageLevelOptions.map((option) => (
      <MenuItem key={option.value} value={option.value}>
      {option.label}
      </MenuItem>
      ))}
      </Select>
      </FormControl>

      {entry.langue && (
      <Tooltip title="Supprimer cette langue">
      <IconButton
      onClick={() => removeLangue(index)}
      color="error"
      className="delete-langue-btn"
      size="small"
      >
      <DeleteIcon />
      </IconButton>
      </Tooltip>
      )}
      </div>
      ))}

      <Button
      variant="outlined"
      onClick={addLangue}
      className="ajouter-langue-btn"
      >
      + Ajouter une langue
      </Button>
      </div>



      <TextField
      label="Informations complémentaires"
      value={data.infoComplementaires || ''}
      onChange={(e) => onChange('infoComplementaires', e.target.value)}
      className="step-two-half"
      multiline
      minRows={1}
      error={!!errors.infoComplementaires}
      helperText={errors.infoComplementaires}
      />

    </form>
  );
};

export default StepTwo;
